<template>
    <div class="px-4 py-3 space-y-6">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-xl font-semibold text-gray-800">Tickets</h1>
          <!-- Actions -->
    <div class="flex flex-row sm:items-center sm:space-x-2">

    </div>
    </div>
<!-- Modal Détails Ticket -->
<div v-if="openModalTicketDetails" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-xl  max-w-lg w-11/12 md:w-2/3 lg:w-1/2 p-6 relative shadow-lg">
    <!-- Bouton fermeture -->
    <button 
      @click="openModalTicketDetails = false" 
      class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl font-bold"
    >
      &times;
    </button>

    <!-- Titre -->
    <h2 class="text-lg font-semibold mb-6 text-gray-800">Détails du Ticket</h2>

    <div class="px-2 py-1 space-y-4">
      <!-- Titre -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Titre</label>
        <p class="w-2/3 text-sm text-gray-800">{{ ticketDetails.titre }}</p>
      </div>
      <hr />

      <!-- Sujet -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Sujet</label>
        <p class="w-2/3 text-sm text-gray-800">{{ ticketDetails.sujet }}</p>
      </div>
      <hr />

      <!-- Type -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Type</label>
        <p class="w-2/3 text-sm text-gray-800">{{ ticketDetails.type }}</p>
      </div>
      <hr />

      <!-- Priorité -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Priorité</label>
        <p class="w-2/3 text-sm text-gray-800">{{ ticketDetails.priorite }}</p>
      </div>
      <hr />

      <!-- Projet -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Projet associé</label>
        <p class="w-2/3 text-sm text-gray-800">
          {{ ticketDetails.projetId?.nomProjet || 'Non défini' }}
        </p>
      </div>
      <hr />

      <!-- Statut -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Statut</label>
        <p class="w-2/3 text-sm" :class="statusClass(ticketDetails.statut)">
          {{ ticketDetails.statut }}
        </p>
      </div>
      <hr />

      <!-- Date -->
      <div class="flex items-center justify-between">
        <label class="w-1/3 text-gray-600 font-medium text-sm">Date de création</label>
        <p class="w-2/3 text-sm text-gray-800">
          {{ new Date(ticketDetails.createdAt).toLocaleString() }}
        </p>
      </div>
      <hr />

      <!-- Commentaires -->
      <div v-if="ticketDetails.commentaires?.length" class="pt-2">
        <h3 class="text-sm font-semibold text-gray-700 mb-2">Réponses / Commentaires :</h3>
        <div class="space-y-2 max-h-40 overflow-y-auto pr-2">
          <div v-for="(com, idx) in ticketDetails.commentaires" :key="idx" class="p-2 border rounded-lg bg-gray-50 shadow-sm">
            <p class="text-sm">
              <strong class="text-blue-600">{{ com.auteur }}</strong> : {{ com.message }}
            </p>
            <p class="text-xs text-gray-500 mt-1">
              {{ new Date(com.date).toLocaleString() }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Bouton -->
    <div class="mt-6 flex justify-end">
      <button 
        @click="openModalTicketDetails = false" 
        class="bg-blue-600 text-white px-6 py-2 rounded-lg text-sm hover:bg-blue-700 transition"
      >
        Fermer
      </button>
    </div>
  </div>
</div>



    

    <!-- Cards Marketing -->
    <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <!-- Card: Total de Tickets -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Total de Tickets</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M12 12c2.485 0 4.5-2.015 4.5-4.5S14.485 3 12 3 7.5 5.015 7.5 7.5 9.515 12 12 12z"/>
              <path stroke-width="1.5" d="M4.5 21v-1.5C4.5 17.567 7.567 15 12 15s7.5 2.567 7.5 4.5V21"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ totalTickets }}</div>
        </div>
      </div>

      <!-- Card: Prospects contactés -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Tickets Résolus</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M3 7.5L12 13.5 21 7.5"/>
              <rect x="3" y="5.25" width="18" height="13.5" rx="2.25" stroke-width="1.5"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ TicketsResolu }}</div>
        </div>
      </div>

      <!-- Card: Prospects en attente -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Tickets en attente</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M7.5 8.25h9M7.5 12h6M4.5 19.5l3.75-3.75h9.75A2.25 2.25 0 0 0 20.25 13.5V6.75A2.25 2.25 0 0 0 18 4.5H6A2.25 2.25 0 0 0 3.75 6.75v9"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ TicketsAttente }}</div>
        </div>
      </div>

      <!-- Card: Prospects acceptés -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Tickets Aujourd'hui </div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6-6 6 6"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-center justify-between">
          <div class="flex items-baseline gap-2">
            <div class="text-3xl font-semibold text-gray-900">{{ prospectsAcceptees }}</div>
          </div>
          <span
            class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium"
            :class="TicketsUrgent >= 0 ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'"
          >
            <svg v-if="TicketsUrgent >= 0" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6-6 6 6"/>
            </svg>
            <svg v-else class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6 6 6-6"/>
            </svg>
            <span>{{ TicketsUrgent >= 0 ? 'En hausse' : 'En baisse' }}</span>
          </span>
        </div>
      </div>
    </div>

    <!-- Tableau des prospects -->
    <div class="overflow-x-auto bg-white shadow-sm rounded-2xl border border-gray-100">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Titre</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tickets</th>
             <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Problème</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date contacté</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="prospect in prospects" :key="prospect.telephone">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ prospect.titre }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ prospect.type }}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ prospect.probleme }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ prospect.dateContact }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                :class="statusClass(prospect.status)"
              >
                {{ prospect.status }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm flex gap-2">
              <button @click="voirProspect(prospect)" class="p-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition" title="Voir">
                <!-- Eye Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
              <button @click="supprimerProspect(prospect)" class="p-2 bg-red-50 text-red-600 rounded hover:bg-red-100 transition" title="Supprimer">
                <!-- Trash Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m-6 0V5a2 2 0 012-2h2a2 2 0 012 2v2"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import axios from "axios"

// 📊 Variables des stats
const totalTickets = ref(0)
const TicketsResolu = ref(0)
const TicketsAttente = ref(0)
const TicketsUrgent = ref(0)

// 📋 Liste des tickets
const prospects = ref([])

// 🎨 Modal
const openModalTicketDetails = ref(false)
const ticketDetails = ref({})

// 🎨 Classe CSS selon status
const statusClass = (status) => {
  switch (status) {
    case "Résolu":
      return "bg-green-100 text-green-800"
    case "En attente":
      return "bg-yellow-100 text-yellow-800"
    case "Nouveau":
      return "bg-blue-100 text-blue-800"
    case "Urgent":
      return "bg-red-100 text-red-800"
    default:
      return "bg-gray-100 text-gray-800"
  }
}

// 👁 Voir un ticket
const voirProspect = async (prospect) => {
  try {
    const token = localStorage.getItem("token")
    const response = await axios.get(`https://datafuseweb-95a5588f8542.herokuapp.com/api/tickets/${prospect._id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })

    ticketDetails.value = response.data.ticket
    openModalTicketDetails.value = true
  } catch (err) {
    console.error("Erreur récupération ticket :", err)
    alert("Impossible de charger le ticket.")
  }
}

// 🗑 Supprimer un ticket (local front)
const supprimerProspect = (prospect) => {
  if (confirm(`Supprimer le ticket ${prospect.ticket} de ${prospect.nom} ?`)) {
    prospects.value = prospects.value.filter(p => p._id !== prospect._id)
  }
}

// 🔹 Récupérer tous les tickets du client
const fetchTickets = async () => {
  try {
    const token = localStorage.getItem("token")
    const response = await axios.get("https://datafuseweb-95a5588f8542.herokuapp.com/api/tickets/mes-tickets", {
      headers: { Authorization: `Bearer ${token}` },
    })

    const tickets = response.data.tickets
    prospects.value = tickets.map(t => ({
      _id: t._id,
      nom: t.clientId?.prenom + " " + t.clientId?.nom,
      ticket: t._id,
      titre: t.titre || t.sujet,
      probleme: t.sujet,
      dateContact: new Date(t.createdAt).toLocaleDateString(),
      status: t.statut || "Nouveau",
      priorite: t.priorite || "Moyenne",
      type: t.type || "Question",
      projet: t.projetId?.nomProjet || "Non défini",
    }))

    // 🔹 Statistiques
    totalTickets.value = tickets.length
    TicketsResolu.value = tickets.filter(t => t.statut === "Résolu").length
    TicketsAttente.value = tickets.filter(t => t.statut === "En attente").length
    TicketsUrgent.value = tickets.filter(t => t.priorite === "Urgent").length

  } catch (err) {
    console.error("Erreur récupération tickets :", err)
  }
}

onMounted(fetchTickets)
</script>


